import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { entryRequestService } from '@api/services/services';
import { EntryRequestDto } from '@api/models/invitation/EntryRequestDto';
import { getDateForApi } from '../../utils/date';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

export interface EntryRequestListFilter extends ListFilter {
  invitation?: ReferenceDto;
}

export type EntryRequestInvitationListState = ListType<EntryRequestDto, EntryRequestListFilter>;

const initialState: EntryRequestInvitationListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'dateFrom',
    sortDesc: false,
  },
};

export const entryRequestInvitationListSlice = listSlice({
  name: 'entryRequestInvitationList',
  initialState,
});

export const selectEntryRequestInvitationList = (state: RootState) => state.entryRequestInvitationList;
export const entryRequestInvitationListActions = entryRequestInvitationListSlice.actions;

export const getEntryRequestInvitationList =
  (cancelToken: CancelToken, invitationId: string, from?: Date) => (dispatch: AppDispatch) => {
    const storeState = store.getState();
    const data = selectEntryRequestInvitationList(storeState);

    const handleGetData = (size: number) => {
      return entryRequestService.getEntryRequestsByCompany({
        invitations: [invitationId],
        page: data.query.page,
        dateFrom: from ? getDateForApi(from) : undefined,
        size,
        sort: getListSort(data),
      }, {
        cancelToken: cancelToken
      });
    };

    getList({
      dispatch,
      cancelToken,
      state: data.state,
      actions: entryRequestInvitationListActions,
      getData: handleGetData,
    });
  };
